export type PermissionMatcher = (module: string) => boolean;

export const buildPermissionMatcher = (
  permission: string
): PermissionMatcher => {
  const exp = new RegExp(
    permission.replace(/(:\*)/g, "(:(.+)?)?").replace(/READ$/g, "(read|write)")
  );
  return (module: string) => Boolean(module.match(exp));
};
